import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/pecom.by/www/frontend/layouts/default.vue").then(m => m.default || m))
}